import React from 'react'

import { Skeleton } from '../../../../../ui/skeleton'

const CardItem = () => {
  return (
    <div className="flex items-center justify-between py-2.5 sm:py-3">
      <Skeleton className="h-3.5 sm:h-5 w-28 sm:w-32" />
      <Skeleton className="h-3.5 sm:h-5 w-28 sm:w-40" />
    </div>
  )
}

export const CardEmpty = () => {
  return (
    <div className="rounded-xl border border-black/10 p-3 sm:p-6">
      <Skeleton className="mb-6 h-5 w-20 sm:w-24" />
      <div className="divide-y divide-black/10">
        {Array.from({ length: 5 }).map((_, index) => (
          <CardItem key={index} />
        ))}
      </div>
    </div>
  )
}
